import type { SVGProps } from "react";

export function IconWhiteCart(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M34 7V15H41V7M57 42H16V7H7M22.5 7H52.5V37H22.5V7ZM15 51.5C15 50.0413 15.5795 48.6424 16.6109 47.6109C17.6424 46.5795 19.0413 46 20.5 46C21.9587 46 23.3576 46.5795 24.3891 47.6109C25.4205 48.6424 26 50.0413 26 51.5C26 52.9587 25.4205 54.3576 24.3891 55.3891C23.3576 56.4205 21.9587 57 20.5 57C19.0413 57 17.6424 56.4205 16.6109 55.3891C15.5795 54.3576 15 52.9587 15 51.5ZM47 51.5C47 50.0413 47.5795 48.6424 48.6109 47.6109C49.6424 46.5795 51.0413 46 52.5 46C53.9587 46 55.3576 46.5795 56.3891 47.6109C57.4205 48.6424 58 50.0413 58 51.5C58 52.9587 57.4205 54.3576 56.3891 55.3891C55.3576 56.4205 53.9587 57 52.5 57C51.0413 57 49.6424 56.4205 48.6109 55.3891C47.5795 54.3576 47 52.9587 47 51.5Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
